module.exports = __webpack_public_path__ + "officialStatic/img/teacherA.6115fe1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/smartCampus/role/teacherA.png
// module id = NbZH
// module chunks = 0